import config from "../config";

const baseUrl = config.base_url + "z_image_v2/";

export default {
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    remove: {
        url: baseUrl + "delete",
        type: "get",
    },
};
